import { useEffect, useState } from "react";

import { validatePassword, type PasswordStrength } from "~/utils/password";

export function usePasswordValidation(password: string, delay = 350) {
  const [validation, setValidation] = useState<{
    valid: boolean;
    errors: string[];
    strength: PasswordStrength;
  } | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!password) {
        setValidation(null);
        return;
      }

      setValidation(validatePassword(password));
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, password]);

  return validation;
}
